<!-- Start Content -->
<div class="content-area">
   <div class="title-block">
      <h1>{{title}}</h1>
      <div class="title-block__right">
        <a class="back-btn" href="javascript:void(0);" [routerLink]="['/admin/settings']"><i class="back-new"></i>
          Back</a>
      </div>
    </div>

  <p-tabView class="tab-outer admin-application-setting notification-settings-outer">
    <!-- For Patient Templates-->
    <p-tabPanel header="Patient">
      <div class="notifaction-templates">

        <div class="notifaction-templates__block" [ngClass]="groupName.isGroupCollapse ? '' : 'add-border'"
          *ngFor="let groupName of settingsGroupNotificationListResponseModel;let i = index">
          <div class="notifaction-templates__header" (click)="ReminderclickEvent(groupName)">
            <h2 class="notifaction-templates__title" style="cursor:pointer;">{{groupName.appModuleDisplayFeatureName}}
            </h2>
            <a class="notifaction-templates__arrow" href="javascript:void(0);"
              [ngClass]="groupName.isGroupCollapse ? 'uparrow' : ''">
              <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12.0155 8.3053L7.05413 3.2406L2.09279 8.3053L0.108259 7.29236L7.05413 0.201782L14 7.29236L12.0155 8.3053Z"
                  fill="#575757" />
              </svg>
            </a>
          </div>
          <div class="notifaction-templates__content" [ngClass]="groupName.isGroupCollapse ? 'hideblock' : 'showblock'">
            <div class="notifaction-templates__template-header">
              <h3 class="notifaction-templates__template-header-title">Templates</h3>
              <div class="notifaction-templates__template-right">
                <div class="notifaction-templates__email-checkbox form__checkbox-outer">
                  <p-checkbox name="groupEmail" binary="true" label="Email"
                    [(ngModel)]="groupName.isEmailSelectAllCheck"
                    (onChange)="emailGroupCheckClick($event, settingsGroupNotificationListResponseModel[i])" inputId="groupEmail1"></p-checkbox>
                  <label class="form__label" for="groupEmail1">Email</label>
                    <!-- <h3 class="notifaction-templates__template-header-title">Email</h3> -->
                </div>
                <div class="notifaction-templates__sms-checkbox form__checkbox-outer">
                  <p-checkbox name="groupSMS" binary="true" label="SMS" [(ngModel)]="groupName.isSMSSelectAllCheck"
                    (onChange)="smsGroupCheckClick($event, settingsGroupNotificationListResponseModel[i])" inputId="groupSMS1"></p-checkbox>
                  <!-- <h3 class="notifaction-templates__template-header-title">SMS</h3> -->
                   <label class="form__label" for="groupSMS1">SMS</label>
                </div>
              </div>
            </div>

            <div class="notifaction-templates__template-body"
              *ngFor="let subGroup of settingsGroupNotificationListResponseModel[i].notificationTemplateList">

              <h3 class="notifaction-templates__template-header-title">{{subGroup?.appNotificationTemplateName}}</h3>
              <div class="notifaction-templates__template-right">
                <div class="notifaction-templates__email-checkbox">
                  <p-checkbox name="groupEmail" binary="true" inputId="email"
                    [(ngModel)]="subGroup.appNotificationInEmail" (onChange)="emailCheckClick($event,subGroup)"
                    [disabled]="!DisaplyViewButton(subGroup,'Email')"></p-checkbox>

                  <a href="javascript:void(0);" class="notifaction-templates__view-icon"
                    (click)="viewEmail($event,subGroup)" [ngClass]="!DisaplyViewButton(subGroup,'Email')?'disable':''">
                    <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M13.0627 7.43831C13.0627 8.96586 11.8244 10.2041 10.2969 10.2041C8.76936 10.2041 7.53107 8.96586 7.53107 7.43831C7.53107 5.91075 8.76936 4.6725 10.2969 4.6725C11.8244 4.6725 13.0627 5.91075 13.0627 7.43831Z"
                        stroke="#626262" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      <path
                        d="M1.5 7.43829C2.6748 3.69789 6.1692 0.984741 10.2973 0.984741C14.4254 0.984741 17.9198 3.69792 19.0946 7.43829C17.9198 11.1787 14.4254 13.8918 10.2973 13.8918C6.16919 13.8918 2.67478 11.1787 1.5 7.43829Z"
                        stroke="#626262" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </a>
                  <a href="javascript:void(0);" class="notifaction-templates__edit-icon"
                    (click)="emailToggel($event,subGroup.appNotificationEventName,subGroup)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="103.901" height="98.574"
                      viewBox="0 0 103.901 98.574">
                      <g id="edit-icon-new" transform="translate(-52.983 -52.983)">
                        <path id="Path_3" data-name="Path 3"
                          d="M323.731,72.125l13.32,13.313ZM332.3,60.4,296.28,96.412a13.319,13.319,0,0,0-3.648,6.8l-3.327,16.653,16.653-3.333a13.305,13.305,0,0,0,6.8-3.641l36.016-36.016A11.655,11.655,0,1,0,332.3,60.4Z"
                          transform="translate(-202.246)" fill="none" stroke="#6f64a7" stroke-linecap="round"
                          stroke-linejoin="round" stroke-width="8" />
                        <path id="Path_4" data-name="Path 4"
                          d="M152.884,117.371v18.115a11.745,11.745,0,0,1-3.745,8.539,13.177,13.177,0,0,1-9.041,3.537H69.769a13.179,13.179,0,0,1-9.042-3.537,11.746,11.746,0,0,1-3.745-8.539V69.066a11.746,11.746,0,0,1,3.745-8.539,13.178,13.178,0,0,1,9.042-3.537H88.95"
                          transform="translate(0 -0.006)" fill="none" stroke="#6f64a7" stroke-linecap="round"
                          stroke-linejoin="round" stroke-width="8" />
                      </g>
                    </svg>
                  </a>
                </div>
                <div class="notifaction-templates__sms-checkbox">
                  <p-checkbox name="groupEmail" binary="true" inputId="sms" [(ngModel)]="subGroup.appNotificationInSms"
                    (onChange)="smsCheckClick($event, subGroup)"
                    [disabled]="!DisaplyViewButton(subGroup,'SMS')"></p-checkbox>
                  <a href="javascript:void(0);" class="notifaction-templates__view-icon"
                    (click)="viewSMS($event,subGroup)" [ngClass]="!DisaplyViewButton(subGroup,'SMS')?'disable':''">
                    <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M13.0627 7.43831C13.0627 8.96586 11.8244 10.2041 10.2969 10.2041C8.76936 10.2041 7.53107 8.96586 7.53107 7.43831C7.53107 5.91075 8.76936 4.6725 10.2969 4.6725C11.8244 4.6725 13.0627 5.91075 13.0627 7.43831Z"
                        stroke="#626262" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      <path
                        d="M1.5 7.43829C2.6748 3.69789 6.1692 0.984741 10.2973 0.984741C14.4254 0.984741 17.9198 3.69792 19.0946 7.43829C17.9198 11.1787 14.4254 13.8918 10.2973 13.8918C6.16919 13.8918 2.67478 11.1787 1.5 7.43829Z"
                        stroke="#626262" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </a>
                  <a href="javascript:void(0);" class="notifaction-templates__edit-icon"
                    (click)="smsToggle($event,subGroup.appNotificationEventName,subGroup)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="103.901" height="98.574"
                      viewBox="0 0 103.901 98.574">
                      <g id="edit-icon-new" transform="translate(-52.983 -52.983)">
                        <path id="Path_3" data-name="Path 3"
                          d="M323.731,72.125l13.32,13.313ZM332.3,60.4,296.28,96.412a13.319,13.319,0,0,0-3.648,6.8l-3.327,16.653,16.653-3.333a13.305,13.305,0,0,0,6.8-3.641l36.016-36.016A11.655,11.655,0,1,0,332.3,60.4Z"
                          transform="translate(-202.246)" fill="none" stroke="#6f64a7" stroke-linecap="round"
                          stroke-linejoin="round" stroke-width="8" />
                        <path id="Path_4" data-name="Path 4"
                          d="M152.884,117.371v18.115a11.745,11.745,0,0,1-3.745,8.539,13.177,13.177,0,0,1-9.041,3.537H69.769a13.179,13.179,0,0,1-9.042-3.537,11.746,11.746,0,0,1-3.745-8.539V69.066a11.746,11.746,0,0,1,3.745-8.539,13.178,13.178,0,0,1,9.042-3.537H88.95"
                          transform="translate(0 -0.006)" fill="none" stroke="#6f64a7" stroke-linecap="round"
                          stroke-linejoin="round" stroke-width="8" />
                      </g>
                    </svg>
                  </a>
                </div>
              </div>

              <!-- Sub template-->
              <div class="sub-template" *ngIf="subGroup.appNotificationEventName =='AppointmentInvitation'">
                <div class="notifaction-templates__template-header">
                  <h3 class="notifaction-templates__template-header-title">
                    Sub Templates
                    <span>(Max. 5 sub templates are allowed)</span>
                  </h3>
                  <div class="notifaction-templates__template-right">
                    <div class="notifaction-templates__email-checkbox">
                      <p-checkbox name="groupEmail" binary="true" label="Email" [(ngModel)]="groupEmailChecked"
                        (onChange)="GroupSubTemplateChecked(subGroup.appNotificationId,true,groupEmailChecked)" inputId="groupEmail2"></p-checkbox>
                   <label class="form__label" for="groupEmail2">Email</label>

                    </div>
                    <div class="notifaction-templates__sms-checkbox">
                      <p-checkbox name="groupSMS" binary="true" label="SMS" [(ngModel)]="groupSMSChecked"
                        (onChange)="GroupSubTemplateChecked(subGroup.appNotificationId,false,groupSMSChecked)" inputId="groupSMS2"></p-checkbox>
                    <label class="form__label" for="groupSMS2">SMS</label>

                    </div>
                    <a class="add-btn" [ngClass]="subGroup?.notificationSubTemplate.length >= 5 ? 'disable':''"
                      href="javascript:void(0);" (click)="CreateSubTemplate(subGroup)">
                      <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M22 11.5C22 14.4174 20.8411 17.2153 18.7782 19.2782C16.7153 21.3411 13.9174 22.5 11 22.5C8.08262 22.5 5.28473 21.3411 3.22183 19.2782C1.15893 17.2153 0 14.4174 0 11.5C0 8.58262 1.15893 5.78473 3.22183 3.72183C5.28473 1.65893 8.08262 0.5 11 0.5C13.9174 0.5 16.7153 1.65893 18.7782 3.72183C20.8411 5.78473 22 8.58262 22 11.5ZM11.6875 6.6875C11.6875 6.50516 11.6151 6.3303 11.4861 6.20136C11.3572 6.07243 11.1823 6 11 6C10.8177 6 10.6428 6.07243 10.5139 6.20136C10.3849 6.3303 10.3125 6.50516 10.3125 6.6875V10.8125H6.1875C6.00516 10.8125 5.8303 10.8849 5.70136 11.0139C5.57243 11.1428 5.5 11.3177 5.5 11.5C5.5 11.6823 5.57243 11.8572 5.70136 11.9861C5.8303 12.1151 6.00516 12.1875 6.1875 12.1875H10.3125V16.3125C10.3125 16.4948 10.3849 16.6697 10.5139 16.7986C10.6428 16.9276 10.8177 17 11 17C11.1823 17 11.3572 16.9276 11.4861 16.7986C11.6151 16.6697 11.6875 16.4948 11.6875 16.3125V12.1875H15.8125C15.9948 12.1875 16.1697 12.1151 16.2986 11.9861C16.4276 11.8572 16.5 11.6823 16.5 11.5C16.5 11.3177 16.4276 11.1428 16.2986 11.0139C16.1697 10.8849 15.9948 10.8125 15.8125 10.8125H11.6875V6.6875Z"
                          fill="#5C5C5C" />
                      </svg>
                    </a>
                  </div>
                </div>
                <div class="notifaction-templates__template-body"
                  *ngFor="let item of subGroup?.notificationSubTemplate; let index = index">
                  <div class="input-edit-table" [ngClass]="editState[index] ? 'edit-box' : ''">
                    <input type="text" class="form__control" [(ngModel)]="item.appNotificationEventName" pInputText
                      maxlength="300" />

                    <div class="action-icon">
                      <a (click)="toggleEditState(index,item.appNotificationEventName)" class="edit-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="103.901" height="98.574"
                          viewBox="0 0 103.901 98.574">
                          <g id="edit-icon-new" transform="translate(-52.983 -52.983)">
                            <path id="Path_3" data-name="Path 3"
                              d="M323.731,72.125l13.32,13.313ZM332.3,60.4,296.28,96.412a13.319,13.319,0,0,0-3.648,6.8l-3.327,16.653,16.653-3.333a13.305,13.305,0,0,0,6.8-3.641l36.016-36.016A11.655,11.655,0,1,0,332.3,60.4Z"
                              transform="translate(-202.246)" fill="none" stroke="#6f64a7" stroke-linecap="round"
                              stroke-linejoin="round" stroke-width="8" />
                            <path id="Path_4" data-name="Path 4"
                              d="M152.884,117.371v18.115a11.745,11.745,0,0,1-3.745,8.539,13.177,13.177,0,0,1-9.041,3.537H69.769a13.179,13.179,0,0,1-9.042-3.537,11.746,11.746,0,0,1-3.745-8.539V69.066a11.746,11.746,0,0,1,3.745-8.539,13.178,13.178,0,0,1,9.042-3.537H88.95"
                              transform="translate(0 -0.006)" fill="none" stroke="#6f64a7" stroke-linecap="round"
                              stroke-linejoin="round" stroke-width="8" />
                          </g>
                        </svg>
                      </a>

                      <a (click)="saveEventName(item,subGroup,index)" class="save-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                          <path fill="#6F64A7"
                            d="M21.21,5.29a1,1,0,0,0-1.42,0L8.5,16.59l-4.29-4.3a1,1,0,0,0-1.42,1.42l5,5a1,1,0,0,0,1.42,0l12-12A1,1,0,0,0,21.21,5.29Z" />
                        </svg>
                      </a>
                      <a (click)="cancelEdit(index)" class="cancel-icon">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M13.8755 2.17661L2.12453 13.8234" stroke="#6F64A7" stroke-width="2" />
                          <path d="M13.8232 13.8755L2.17637 2.12453" stroke="#6F64A7" stroke-width="2" />
                        </svg>
                      </a>
                    </div>
                  </div>

                  <div class="notifaction-templates__template-right">
                    <div class="notifaction-templates__email-checkbox">
                      <p-checkbox [ngClass]="item.appNotificationEmailTemplateFormat.trim() == '' ? 'disable':''"
                        name="groupEmail" binary="true" inputId="email" [(ngModel)]="item.isEmailChecked"
                        (onChange)="SubTemplateCheck(true,item)"></p-checkbox>
                      <a href="javascript:void(0);" class="notifaction-templates__view-icon"
                        [ngClass]="item.appNotificationEmailTemplateFormat.trim() == '' ? 'disable':''"
                        (click)="viewSubEmail(item)">
                        <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M13.0627 7.43831C13.0627 8.96586 11.8244 10.2041 10.2969 10.2041C8.76936 10.2041 7.53107 8.96586 7.53107 7.43831C7.53107 5.91075 8.76936 4.6725 10.2969 4.6725C11.8244 4.6725 13.0627 5.91075 13.0627 7.43831Z"
                            stroke="#626262" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          <path
                            d="M1.5 7.43829C2.6748 3.69789 6.1692 0.984741 10.2973 0.984741C14.4254 0.984741 17.9198 3.69792 19.0946 7.43829C17.9198 11.1787 14.4254 13.8918 10.2973 13.8918C6.16919 13.8918 2.67478 11.1787 1.5 7.43829Z"
                            stroke="#626262" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </a>
                      <a href="javascript:void(0);" class="notifaction-templates__edit-icon"
                        (click)="emailSubToggel(item.appNotificationEventName,item)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="103.901" height="98.574"
                          viewBox="0 0 103.901 98.574">
                          <g id="edit-icon-new" transform="translate(-52.983 -52.983)">
                            <path id="Path_3" data-name="Path 3"
                              d="M323.731,72.125l13.32,13.313ZM332.3,60.4,296.28,96.412a13.319,13.319,0,0,0-3.648,6.8l-3.327,16.653,16.653-3.333a13.305,13.305,0,0,0,6.8-3.641l36.016-36.016A11.655,11.655,0,1,0,332.3,60.4Z"
                              transform="translate(-202.246)" fill="none" stroke="#6f64a7" stroke-linecap="round"
                              stroke-linejoin="round" stroke-width="8" />
                            <path id="Path_4" data-name="Path 4"
                              d="M152.884,117.371v18.115a11.745,11.745,0,0,1-3.745,8.539,13.177,13.177,0,0,1-9.041,3.537H69.769a13.179,13.179,0,0,1-9.042-3.537,11.746,11.746,0,0,1-3.745-8.539V69.066a11.746,11.746,0,0,1,3.745-8.539,13.178,13.178,0,0,1,9.042-3.537H88.95"
                              transform="translate(0 -0.006)" fill="none" stroke="#6f64a7" stroke-linecap="round"
                              stroke-linejoin="round" stroke-width="8" />
                          </g>
                        </svg>
                      </a>
                    </div>

                    <div class="notifaction-templates__sms-checkbox">
                      <p-checkbox [ngClass]="item.appNotificationSMSTemplateFormat.trim() == '' ? 'disable':''"
                        name="groupEmail" binary="true" inputId="sms" [(ngModel)]="item.isSMSChecked"
                        (onChange)="SubTemplateCheck(false,item)"></p-checkbox>
                      <a href="javascript:void(0);" class="notifaction-templates__view-icon"
                        [ngClass]="item.appNotificationSMSTemplateFormat.trim() == '' ? 'disable':''"
                        (click)="viewSubSMS(item)">
                        <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M13.0627 7.43831C13.0627 8.96586 11.8244 10.2041 10.2969 10.2041C8.76936 10.2041 7.53107 8.96586 7.53107 7.43831C7.53107 5.91075 8.76936 4.6725 10.2969 4.6725C11.8244 4.6725 13.0627 5.91075 13.0627 7.43831Z"
                            stroke="#626262" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          <path
                            d="M1.5 7.43829C2.6748 3.69789 6.1692 0.984741 10.2973 0.984741C14.4254 0.984741 17.9198 3.69792 19.0946 7.43829C17.9198 11.1787 14.4254 13.8918 10.2973 13.8918C6.16919 13.8918 2.67478 11.1787 1.5 7.43829Z"
                            stroke="#626262" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </a>
                      <a href="javascript:void(0);" class="notifaction-templates__edit-icon"
                        (click)="smsSubToggle(item.appNotificationEventName,item)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="103.901" height="98.574"
                          viewBox="0 0 103.901 98.574">
                          <g id="edit-icon-new" transform="translate(-52.983 -52.983)">
                            <path id="Path_3" data-name="Path 3"
                              d="M323.731,72.125l13.32,13.313ZM332.3,60.4,296.28,96.412a13.319,13.319,0,0,0-3.648,6.8l-3.327,16.653,16.653-3.333a13.305,13.305,0,0,0,6.8-3.641l36.016-36.016A11.655,11.655,0,1,0,332.3,60.4Z"
                              transform="translate(-202.246)" fill="none" stroke="#6f64a7" stroke-linecap="round"
                              stroke-linejoin="round" stroke-width="8" />
                            <path id="Path_4" data-name="Path 4"
                              d="M152.884,117.371v18.115a11.745,11.745,0,0,1-3.745,8.539,13.177,13.177,0,0,1-9.041,3.537H69.769a13.179,13.179,0,0,1-9.042-3.537,11.746,11.746,0,0,1-3.745-8.539V69.066a11.746,11.746,0,0,1,3.745-8.539,13.178,13.178,0,0,1,9.042-3.537H88.95"
                              transform="translate(0 -0.006)" fill="none" stroke="#6f64a7" stroke-linecap="round"
                              stroke-linejoin="round" stroke-width="8" />
                          </g>
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </p-tabPanel>

    <!-- For Therapist Templates-->
    <p-tabPanel header="Therapist">
      <div class="form-content-outer">
        <app-therapist></app-therapist>
      </div>
    </p-tabPanel>

    <p-tabPanel header="Staff" *ngIf="false">
      <div class="form-content-outer">
        <app-staff></app-staff>
      </div>
    </p-tabPanel>

    <p-tabPanel header="Schedule the Reminder">
      <div class="form-content-outer">
        <app-reminder-setting></app-reminder-setting>
      </div>
    </p-tabPanel>

    <div class="loader-block" *ngIf="loading">
      <p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="8" fill="#ffffff"
        animationDuration=".8s">
      </p-progressSpinner>
    </div>

  </p-tabView>
</div>
<!-- End Content -->

<!-- NEW View Email Template -->
<p-dialog header="Title" [(visible)]="viewEmailDialog" [modal]="true">
  <div class="popup-content-outer view-email">
    <div class="view-email__header">
      <img *ngIf="imageUrl" [src]="imageUrl" alt="{{imagealt}}" height="65" title="{{imageTitle}}">
    </div>
    <div class="view-email__content">
      <h1>{{emailTitle}}</h1>
      <h3>{{subject}}</h3>
      <div [innerHtml]="emailTextArea"></div>
    </div>
  </div>
</p-dialog>

<!-- NEW View SMS Template -->
<p-dialog header="Title" [(visible)]="viewSMSDialog" [modal]="true">
  <div class="popup-content-outer view-email">

    <div class="view-email__header">
      <img *ngIf="imageUrl" [src]="imageUrl" alt="{{imagealt}}" height="65" title="{{imageTitle}}">
    </div>
    <div class="view-email__content">
      <h1>{{smsTitle}}</h1>
      <div [innerHtml]="smsTextArea"></div>
    </div>
  </div>
</p-dialog>

<!-- EMAIL Template Popup -->
<p-dialog appendTo="body" [(visible)]="editEmailDialog" styleClass="overly-noti"
  class="search-popup notificationPop notification-settings-email-overly" [modal]="true">
  <div class="notification-overlay-popup">
    <h3 class="notification-overlay-popup__title">{{emailTitle}}</h3>
    <form class="form" [formGroup]="formEmail" autocomplete="off">
      <div class="form__group">
        <label class="form__label">Subject</label>
        <input type="text" class="form__control" formControlName="subject" pInputText maxlength="100">

        <div *ngIf="formEmailSubmitted && fEmail.subject.errors" class="invalid-feedback-error">
          <span *ngIf="fEmail.subject.errors.required || fEmail.subject.errors.whitespace">
            {{validationMessages.subject.required}}</span>
        </div>

      </div>
      <div class="form__group">
        <label class="form__label">Email Message</label>
                      <p-editor  [(ngModel)]="editor.emailText" #editorText [ngModelOptions]="{standalone: true}" [style]="{height: '200px'}"></p-editor>

        <div *ngIf="formEmailSubmitted && emailTextValidation" class="invalid-feedback-error">
          <span>Email message is required</span>
        </div>
      </div>
      <div class="form__group tags-box">
        <label class="form__label">Tags</label>
        <p-select optionValue="value" appendTo="body" optionLabel="displayName" class="form__dropdown select-box" placeholder="Select Tags"
          [options]="enumEmailModel" (onChange)="onChange($event)" filter="true">
        </p-select>
      </div>

      <div class="btns">
        <button class="btn btn--primary" (click)="saveEditDialog($event,isSubTemplateSelected,true)">Save</button>
        <button class="btn btn--secondary" (click)="emailCancel()">Cancel</button>
        <!-- <button class="btn btn--secondary" (click)="emailReset()">Reset</button> -->
      </div>
    </form>
  </div>
</p-dialog>

<!-- SMS Template Popup -->

<p-dialog appendTo="body" [(visible)]="editSMSDialog" styleClass="overly-sms"
  class="search-popup notificationPop notification-settings-sms-overly" [modal]="true">
  <div class="notification-overlay-popup">
    <h3 class="notification-overlay-popup__title">{{smsTitle}}</h3>
    <form class="form" [formGroup]="formSMS" autocomplete="off">

      <div class="form__group">
        <label class="form__label">SMS Message</label>
        <textarea class="form__textarea" #editorTextSMS formControlName="smsTextArea" [(ngModel)]="smsTextArea"
          pInputTextarea #box (keyup)="0"></textarea>
        <div *ngIf="formSMSSubmitted && fSMS.smsTextArea.errors" class="invalid-feedback-error">
          <span *ngIf="fSMS.smsTextArea.errors.required || fEmail.smsTextArea.errors.whitespace">
            {{validationMessages.smsTextArea.required}}</span>
        </div>
        <!--<p class="character-text">{{250 - box.value?.length}} characters are left...</p>-->
      </div>

      <div class="form__group">
        <label class="form__label">Tags</label>
        <p-select optionValue="value" appendTo="body" optionLabel="displayName" class="form__dropdown select-box" placeholder="Select Tags"
          [options]="enumSMSModel" (onChange)="onChangeSMS($event)" filter="true">
        </p-select>
      </div>
      <div class="btns">
        <button class="btn btn--primary" (click)="saveEditDialog($event,isSubTemplateSelected,false)">Save</button>
        <button class="btn btn--secondary" (click)="smsCancel()">Cancel</button>
      </div>
    </form>
  </div>
</p-dialog>
